import { getBaseUrlB2B } from "../AuthService/BaseURLS";
import { axiosWithToken } from "../AuthService/AxiosToken";
export function getOperationInstructionsPdfULR (config) {
    return new Promise((resolve, reject) => {
        axiosWithToken.get(getBaseUrlB2B() + "/provider/operationInstructions",config )
            .then(res => {
                resolve(res.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}